import m from "../../geodata/es2015/worldUltra";
window.am4geodata_worldUltra = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/worldUltra.js
// module id = null
// module chunks = 